import React, { FC } from "react";

import SectionHeader from "components/common/Ui/SectionHeader/SectionHeader";
import { Tabs, TTabItem } from "components/common/Tabs";
import { ProductTypeEnum } from "core/enum/product-type.enum";
import { StoreList } from "./StoreList";

const Store: FC = () => {
  const tabs: TTabItem[] = [
    {
      label: "فروشگاه محصولات",
      element: <StoreList productType={ProductTypeEnum.PhysicalProduct} />,
    },
    {
      label: "فروشگاه خدمات",
      element: <StoreList productType={ProductTypeEnum.Service} />,
    },
  ];

  return (
    <>
      <SectionHeader title="فروشگاه" className="mb-5" />
      <div dir="rtl" style={{ textAlign: "right" }}>
        <Tabs tabs={tabs} />
      </div>
    </>
  );
};

export { Store };
